import axios from 'axios';

const API_KEY_MAPBOX = process.env.REACT_APP_MAPBOX_PUBKEY;

const getAddress = async (long: number, lat: number) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${long},${lat}.json`;
    const access_token = `?access_token=${API_KEY_MAPBOX}`;
    try {
        const response = await axios.get(`${url}${access_token}`);
        if (response && response.data) {
            const { features } = response.data;
            features.forEach((e) => {
                if (e.id.lastIndexOf('') !== -1) {
                    return e.place_name;
                }
            });
            return features[0].place_name || null;
        } else return null;
    } catch (error) {
        return null;
    }
};

export const LocationService = {
    getAddress
};
